import React from 'react';
import { cn } from '../../shared/utils';

/**
 * Colour by how much this module costs, not by how big the number looks.
 * Realtime Database egress is billed per GB, so a screen that pulls tens of
 * megabytes on every open is the one worth opening up — the thresholds are set
 * where a habit (a few opens a day, by a few people) starts to show on the bill.
 */
const meterTone = (bytes) => {
    if (bytes >= 20 * 1024 * 1024) return 'bg-red-500/90 text-white';       // ~₹0.50+ per open
    if (bytes >= 2 * 1024 * 1024) return 'bg-amber-400/90 text-amber-950';
    return 'bg-slate-700/80 text-slate-300';
};

const short = (bytes) => {
    const b = Number(bytes) || 0;
    if (b >= 1024 * 1024 * 1024) return `${(b / 1073741824).toFixed(1)}G`;
    if (b >= 1024 * 1024) return `${(b / 1048576).toFixed(b >= 10485760 ? 0 : 1)}M`;
    if (b >= 1024) return `${Math.round(b / 1024)}K`;
    return `${b}B`;
};

/**
 * `meter` is the bytes this module has pulled from the Realtime Database in this
 * browser since the meter was last reset. It is an approximation used for RANKING
 * modules, never a billing figure — see integrations/rtdbMeter.js.
 */
const SidebarItem = ({ icon: Icon, label, active, onClick, meter, collapsed = false }) => (
    <button
        onClick={onClick}
        title={collapsed ? label : undefined}
        aria-label={collapsed ? label : undefined}
        className={cn(
            "w-full flex items-center rounded-lg transition-all duration-200 mb-1",
            collapsed ? "justify-center py-3" : "space-x-3 px-4 py-3",
            active ? "bg-indigo-600 text-white shadow-lg shadow-indigo-900/50" : "text-indigo-200 hover:bg-indigo-900/50 hover:text-white"
        )}
    >
        <Icon size={20} />
        {!collapsed && <span className="font-medium flex-1 text-left truncate">{label}</span>}
        {!collapsed && meter > 0 && (
            <span
                title={`${label} has downloaded about ${short(meter)}B of database data in this browser. Realtime Database is billed per GB.`}
                className={cn('shrink-0 px-1.5 py-0.5 rounded text-[10px] font-bold tabular-nums', meterTone(meter))}
            >
                {short(meter)}
            </span>
        )}
    </button>
);

export default SidebarItem;
